import { get } from '../utils/makeRequest';

const ADMIN_DASHBOARD_ENDPOINTS = {
  GET_DASHBOARD_STATS: '/admin/dashboard-stats',
};

export const adminDashboardService = {
  /**
   * Get dashboard statistics
   * @returns {Promise} - Dashboard statistics and recent data
   */
  getDashboardStats: async () => {
    return get(ADMIN_DASHBOARD_ENDPOINTS.GET_DASHBOARD_STATS);
  },
};
